import React, { useEffect, useState } from "react";
import { ListItem } from '@mui/material';
import API from "../../Service/Baseservice";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Button, Popover, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";



const ConsultationTimeSlot = () => {

    const [startDate, setStartDate] = useState(null);






    useEffect(() => {
        if (startDate) {
            consultationDaysSlotList();
            fetchBookingList();
        }
    }, [startDate])

    const [dateResponse, setDateResponse] = useState("")
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    // const [popup, setPopup] = useState("")
    const navigate = useNavigate()
    const [daystatus, setDayStatus] = useState("")
    const [popup, setPopup] = useState({ show: false });
    const [bookingList, setBookingList] = useState([]);
    const consultationDaysSlotList = () => {

        let req = {
            consultation_date: startDate ? startDate.format("YYYY-MM-DD") : null,
        }
        API.post("consultationDaysSlotList/Condition", req).then((res) => {
            if (res.data.success === true) {

                setDateResponse(res.data.data)

                if (res.data.success && Array.isArray(res.data.data) && res.data.data.length > 0) {

                    setDayStatus(res.data.data[0].day_status);
                } else {

                    setDayStatus(null);
                }

                const resPonseData = res.data.data
                const starttime =
                    resPonseData.length > 0
                        ? dayjs(resPonseData[0].start_time, "HH:mm")
                        : null;

                const endtime =
                    resPonseData.length > 0
                        ? dayjs(resPonseData[resPonseData.length - 1].end_time, "HH:mm")
                        : null;
                setStartTime(starttime)
                setEndTime(endtime)

            }
        })

    }
    const fetchBookingList = () => {
        const req = {
            booking_date: startDate.format("YYYY-MM-DD"),
            user_timezone: "America/Toronto",
        };

        API.post("consultationBokkinglist/webCondition", req).then((res) => {
            if (res.data.success) {
                setBookingList(res.data.data || []);
            }
        });
    };

    const hasBookings = bookingList.length > 0;



    const handleBookingToggle = () => {
        if (hasBookings) {
            showError(`Cannot change availability. Bookings already exist for this date.`);

            return;
        }

        setDayStatus(prev => (prev === "active" ? "inactive" : "active"));
    };


    const handleStartTimeChange = (newValue) => {
        if (!newValue) {
            setStartTime(null);
            return;
        }

        setStartTime(newValue);

        console.log("Start Time to send:", newValue.format("HH:mm:ss"));
    };

    const handleEndTimeChange = (newValue) => {
        if (!newValue) {
            setEndTime(null);
            return;
        }

        setEndTime(newValue);

        console.log("End Time to send:", newValue.format("HH:mm:ss"));
    };



    const handleDateChange = (newValue) => {
        setStartDate(newValue);


    };

    const bookedTimeRange = React.useMemo(() => {
        if (!bookingList || bookingList.length === 0) return null;

        let minStart = dayjs(bookingList[0].start_time, "HH:mm:ss");
        let maxEnd = dayjs(bookingList[0].end_time, "HH:mm:ss");

        bookingList.forEach(item => {
            const start = dayjs(item.start_time, "HH:mm:ss");
            const end = dayjs(item.end_time, "HH:mm:ss");

            if (start.isBefore(minStart)) {
                minStart = start;
            }

            if (end.isAfter(maxEnd)) {
                maxEnd = end;
            }
        });

        return {
            start: minStart,
            end: maxEnd
        };
    }, [bookingList]);

    const updateBtn = () => {
        if (!startDate || !startTime || !endTime) {
            showError("Please select date and time");
            return;
        }

        if (bookingList.length > 0 && bookedTimeRange) {
            if (startTime.isAfter(bookedTimeRange.start)) {
                showError(
                    `Cannot update time. Existing booking must remain intact (${bookedTimeRange.start.format("HH:mm:ss")} - ${bookedTimeRange.end.format("HH:mm:ss")}).`
                );
                return;
            }

            if (endTime.isBefore(bookedTimeRange.end)) {
                showError(
                    `Cannot update time. Existing booking must remain intact (${bookedTimeRange.start.format("HH:mm:ss")} - ${bookedTimeRange.end.format("HH:mm:ss")}).`
                );
                return;
            }
        }

        const req = {
            date: startDate.format("YYYY-MM-DD"),
            start_time: startTime.format("HH:mm:ss"),
            end_time: endTime.format("HH:mm:ss"),
            status: daystatus,
            slot_group: startTime.minute() === 30 ? "SHIFTED_30" : "NORMAL",
        };

        API.post("consultationDateUpdate/add", req)
            .then((res) => {
                setPopup({
                    show: true,
                    title: "Success",
                    message: res.data?.message || "Updated successfully",
                    type: "success",
                    action: "navigate"
                });
            })
            .catch(() => showError("Failed to update. Try again."));
    };

    const showError = (message) => {
        setPopup({
            show: true,
            title: "Validation Error",
            message,
            type: "error",
            action: "stay"
        });
    };


    const calendarStyles = {
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",


        "& .MuiPickersCalendarHeader-root": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
            marginBottom: "8px",
            position: "relative",
        },


        "& .MuiPickersCalendarHeader-labelContainer": {
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            pointerEvents: "none",
        },

        "& .MuiPickersCalendarHeader-label": {
            fontSize: "18px",
            fontWeight: 600,
        },


        "& .MuiPickersArrowSwitcher-root": {
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
        },

        "& .MuiPickersArrowSwitcher-button": {
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            backgroundColor: "#F1F3F4",
        },

        "& .MuiPickersArrowSwitcher-button:hover": {
            backgroundColor: "#E3E5E5",
        },


        "& .MuiDayCalendar-weekDayLabelContainer": {
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            width: "100%",
        },

        "& .MuiDayCalendar-weekDayLabel": {
            width: "100%",
            textAlign: "center",
            fontSize: "14px",
            fontWeight: 500,
        },


        "& .MuiDayCalendar-weekContainer": {
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            width: "100%",
            justifyItems: "center",
        },


        "& .MuiPickersDay-root": {
            width: "40px",
            height: "40px",
            margin: "auto",
            fontSize: "21px",
            borderRadius: "50%",
            backgroundColor: "transparent",
            border: "none",
        },

        "& .MuiPickersDay-root.Mui-selected": {
            backgroundColor: "#E3E5E5",
            color: "#72777A",
            border: "none",
        },


        "& .MuiPickersDay-root.Mui-selected:focus": {
            backgroundColor: "#E3E5E5",
            outline: "none",
        },

        "& .MuiPickersDay-root:focus": {
            backgroundColor: "transparent",
            outline: "none",
        },

        "& .MuiPickersDay-root:hover": {
            backgroundColor: "#E3E5E5",
            border: "none",
        },

        "& .MuiPickersDay-dayOutsideMonth": {
            visibility: "hidden",
        },

        "& .MuiPickersSlideTransition-root": {
            overflow: "hidden",
        },
    };





    return (
        <div>
            <div className="admin-container">
                <div className="news-header">
                    <h2 className="news-title">Consultation Time Slot</h2>
                </div>

                <div className="card  rounded-3  p-4 shadow-lg">


                    <div className='mt-3 d-flex justify-content-center'>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-8 mt-2">
                            <div>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateCalendar
                                        value={startDate}
                                        onChange={handleDateChange}
                                        views={["day"]}
                                        disablePast
                                        sx={calendarStyles}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                    </div>
                </div>

                {dateResponse && (
                    <div className="modal fade  show d-block" >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content custom-card col-lg-5 mx-auto">




                                <div className="modal-header p-3 border-bottom d-flex">





                                    <h5 className="modal-title mb-0 text-center w-100">Time Slot</h5>

                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => {
                                            setDateResponse(false);
                                            setPopup({ show: false });
                                        }}
                                    ></button>


                                </div>



                                {dateResponse.length > 0 ? (


                                    <>


                                        {daystatus !== null && (
                                            <div className="booking-toggle mt-3 mb-3 d-flex ms-3 gap-2">
                                                <label className="switch mb-0">
                                                    <input
                                                        type="checkbox"
                                                        checked={daystatus === "active"}
                                                        onChange={handleBookingToggle}
                                                    />
                                                    <span className="slider"></span>
                                                </label>

                                                <span
                                                    className={
                                                        daystatus === "active"
                                                            ? "status-text status-active"
                                                            : "status-text status-inactive"
                                                    }
                                                >
                                                    {daystatus === "active" ? "Available" : "Not Available"}
                                                </span>

                                            </div>
                                        )}

                                        <div className="d-flex justify-content-center mb-0">
                                            <h5 className="date-slot">
                                                <span className="date-slot-label">Date:</span>{" "}
                                                <span className="date-slot-value">
                                                    {startDate ? startDate.format("YYYY-MM-DD") : "--"}
                                                </span>
                                            </h5>

                                        </div>

                                        <div className="row p-2 mt-3  mb-3 d-flex justify-content-center">




                                            <div className="col-lg-4">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <TimePicker
                                                        label="Start Time"
                                                        value={startTime}
                                                        onChange={handleStartTimeChange}
                                                        views={["hours", "minutes"]}
                                                        ampm={false}
                                                        format="HH:mm"
                                                        timeSteps={{ minutes: 30 }}
                                                        sx={{ width: "100%" }}
                                                    />
                                                </LocalizationProvider>
                                            </div>




                                            <div className="col-lg-4">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <TimePicker
                                                        label="End Time"
                                                        value={endTime}
                                                        onChange={handleEndTimeChange}
                                                        views={["hours", "minutes"]}
                                                        ampm={false}
                                                        format="HH:mm"
                                                        timeSteps={{ minutes: 30 }}
                                                        sx={{ width: "100%" }}
                                                    />
                                                </LocalizationProvider>
                                            </div>

                                        </div>



                                        <div className="modal-body d-flex  justify-content-center">
                                            <h5 className="consult-time text-center">
                                                <span className="consult-label">Time Slot:</span>{" "}
                                                <span className="consult-value">
                                                    {startTime ? dayjs(startTime, "HH:mm:ss").format("HH:mm") : "--"}
                                                    {" - "}
                                                    {endTime ? dayjs(endTime, "HH:mm:ss").format("HH:mm") : "--"}
                                                </span>
                                            </h5>
                                        </div>





                                        <div className="mt-2 mb-4 d-flex justify-content-center">
                                            <button className="btn calendar-btn1" onClick={updateBtn}>Update</button>
                                        </div>
                                    </>) : (<h5 className="modal-title  w-100 text-center mt-4 mb-4">No Time Slot Available</h5>)}

                            </div>
                        </div>
                    </div>
                )}





            </div>
            {
                popup.show && (
                    <div className="popup-overlay">
                        <div className={`popup-box ${popup.type}`}>
                            <h3>{popup.title}</h3>
                            <p>{popup.message}</p>
                            <div className="popup-buttons">
                                <button
                                    className="btn ok-btn"
                                    onClick={() => {
                                        setPopup({ show: false });

                                        if (popup.action === "navigate") {
                                            setDateResponse(false);
                                            navigate("/consultationtimeslot");
                                        }
                                    }}
                                >
                                    OK
                                </button>

                            </div>
                        </div>
                    </div>
                )
            }


        </div >
    )
}

export default ConsultationTimeSlot